export default __webpack_public_path__ + "static/media/icon-arrow.84087786.svg";